class messageDetailCtrl {
    constructor(
        $rootScope,
        $scope,
        httpRequest,
        $stateParams,
        $sce,
    ) {
        $('body').addClass('leftnav-close')
        $rootScope.leftNavDisabled = true
        $scope.breadcrumbs = [{
                name: '消息中心',
                path: 'message.center',
            },
            {
                name: '消息详情',
                path: 'message.detail',
            },
        ]

        $scope.message = {
            noticeTitle: '',
            createTime: '',
            noticeContent: '',
        }

        $scope.to_trusted = function (html_code) {
            return $sce.trustAsHtml(html_code)
        }

        const fetchNoticeByNoticeId = () => {
            const {
                noticeId
            } = $stateParams
            httpRequest.fetchNoticeByNoticeId(noticeId).then((res) => {
                if (res && res.data && res.data.success) {
                    $scope.message.noticeTitle = res.data.value && res.data.value.noticeTitle
                    $scope.message.createTime = res.data.value && res.data.value.createTime
                    $scope.message.noticeContent = res.data.value && res.data.value.noticeContent
                    // NOTE: 需要调用消息更新状态接口
                    setMessageReaded(noticeId)
                }
            })
        }

        const setMessageReaded = (noticeId) => {
            httpRequest.setMessageReaded({
                noticeIds: [noticeId]
            })
        }
        fetchNoticeByNoticeId()
    }
}
messageDetailCtrl.$inject = [
    '$rootScope',
    '$scope',
    'httpRequest',
    '$stateParams',
    '$sce',
]
export default messageDetailCtrl


// WEBPACK FOOTER //
// ./src/app/main/message/messageDetailCtrl.js